import { getDatabase, ref, get } from "firebase/database";

export default async function getHasPinCode(number: string) : Promise<boolean> {

    const snap = await get(ref(getDatabase(), `haspin/${number}`));
    return snap.exists() && snap.val() ? true : false;
}
